import React, { FC, PropsWithChildren } from 'react'

import { useIntl } from 'react-intl'

import { Button, IconButton } from '@themenu/design-system'

import { LegalLinkFooter } from '@app/components/Shared/LegalLinkFooter'
import { HELP_LINK } from '@app/constants'
import { useIsSmallMobile } from '@app/hooks/device'

type InvitationFlowLayoutProps = {
  showBackButton: boolean
  onBack?: () => void
}

export const InvitationFlowLayout: FC<PropsWithChildren<InvitationFlowLayoutProps>> = ({
  showBackButton,
  onBack,
  children,
}) => {
  const isSmallMobile = useIsSmallMobile()
  const { formatMessage } = useIntl()

  return (
    <div className="relative flex flex-1 flex-col items-center justify-center bg-background-contrast xs:gap-24 dark:bg-background-default-dark">
      <header role="banner" className="mt-8 flex w-full justify-between px-20 xs:mt-24">
        {showBackButton ? (
          <div>
            {isSmallMobile ? (
              <div className="my-8 flex min-h-24 items-end justify-start">
                <IconButton
                  variant="alternativeText"
                  size={24}
                  name="chevron-left"
                  onClick={onBack}
                  aria-label={formatMessage({ id: 'invitation_flow.back_button.aria-label' })}
                />
              </div>
            ) : (
              <Button
                variant="secondary"
                size={40}
                onClick={onBack}
                aria-label={formatMessage({ id: 'invitation_flow.back_button.aria-label' })}
              >
                {formatMessage({ id: 'invitation_flow.back_button' })}
              </Button>
            )}
          </div>
        ) : (
          <div className="min-h-40" />
        )}
        <div className="hidden xs:block">
          <Button variant="text" startIcon="help" size={40} component="a" target="_blank" href={HELP_LINK} width="auto">
            {formatMessage({ id: 'sign_in_page.footer.help_button' })}
          </Button>
        </div>
      </header>
      <div className="flex w-full flex-1 flex-col justify-between overflow-auto">
        <main role="main" className="mx-auto flex w-full flex-1 xs:block xs:w-[445px]">
          {children}
        </main>
        {!isSmallMobile && <LegalLinkFooter />}
      </div>
    </div>
  )
}
